
import { FilterContainer } from "./filters/FilterContainer";
import { useJobs } from "@/hooks/useJobs";

interface Filters {
  searchQuery: string;
  locationFilter: string;
  skillFilter: string;
  companyFilter: string;
  roleFilter: string;
  workArrangementFilter: string;
  salaryRange: [number, number];
  industryFilter: string;
}

interface Setters {
  setSearchQuery: (value: string) => void;
  setLocationFilter: (value: string) => void;
  setSkillFilter: (value: string) => void;
  setCompanyFilter: (value: string) => void;
  setRoleFilter: (value: string) => void;
  setWorkArrangementFilter: (value: string) => void;
  setSalaryRange: (value: [number, number]) => void;
  setIndustryFilter: (value: string) => void;
}

interface JobListFiltersProps {
  filters: Filters;
  setters: Setters;
  onApplyFilters: () => void;
  onResetFilters: () => void;
}

export function JobListFilters({
  filters,
  setters,
  onApplyFilters,
  onResetFilters,
}: JobListFiltersProps) {
  const { jobs } = useJobs(false);

  // Extract unique values from jobs
  const uniqueLocations = Array.from(new Set(jobs?.map(job => job.location) || [])).filter(Boolean);
  const uniqueIndustries = Array.from(new Set(jobs?.map(job => job.industry) || [])).filter(Boolean);
  const uniqueSkills = Array.from(new Set(jobs?.flatMap(job => job.key_skills || []) || [])).filter(Boolean);
  const uniqueCompanies = Array.from(new Set(jobs?.map(job => job.organization?.organization) || [])).filter(Boolean);

  return (
    <FilterContainer
      searchQuery={filters.searchQuery}
      onSearchChange={setters.setSearchQuery}
      industryFilter={filters.industryFilter}
      onIndustryChange={setters.setIndustryFilter}
      locationFilter={filters.locationFilter}
      onLocationChange={setters.setLocationFilter}
      sizeFilter=""
      onSizeFilter={() => {}}
      skillFilter={filters.skillFilter}
      onSkillChange={setters.setSkillFilter}
      companyFilter={filters.companyFilter}
      onCompanyChange={setters.setCompanyFilter}
      roleFilter={filters.roleFilter}
      onRoleChange={setters.setRoleFilter}
      workArrangementFilter={filters.workArrangementFilter}
      onWorkArrangementChange={setters.setWorkArrangementFilter}
      salaryRange={filters.salaryRange}
      onSalaryRangeChange={setters.setSalaryRange}
      onApplyFilters={onApplyFilters}
      onResetFilters={onResetFilters}
      uniqueLocations={uniqueLocations}
      uniqueIndustries={uniqueIndustries}
      uniqueSkills={uniqueSkills}
      uniqueCompanies={uniqueCompanies}
    />
  );
}
